<template>
  <div class="clientFundExchange">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList()"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="list-item">
          {{ $t.clientFund.customerNumber }}：{{ item.CustomerNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.customerName }}：{{ item.CustomerName }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.exchangeNo }}：{{ item.ExchangeNumber }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.exchangeCurrency }}：{{ item.ExchangeCurrencyStr }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.exchangeAmount }}：{{ item.ExchangeAmount }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.exchangeBeforeBalance }}：{{ item.ExchangeBeforeBalance }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.exchangeAfterBalance }}：{{ item.ExchangeAfterBalance }}
        </div>
        <div class="list-item">{{ $t.clientFund.rate }}：{{ item.ExchangeRate }}</div>
        <div class="list-item">
          {{ $t.clientFund.toCurrency }}：{{ item.ConvertCurrencyStr }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.toAmount }}：{{ item.ConvertAmount }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.convertBeforeBalance }}：{{ item.ConvertBeforeBalance }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.convertAfterBalance }}：{{ item.ConvertAfterBalance }}
        </div>
        <div class="list-item">
          {{ $t.clientFund.operateDate }}：{{ item.CreateTime }}
        </div>
        <div class="list-item">{{ $t.clientFund.username }}：{{ item.UserName }}</div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, Row, Col, Button } from "vant";

import Vue from "vue";
Vue.use(List).use(Row).use(Col).use(Button);

export default {
  name: "clientFundExchange",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      dialogVisible: false,
      CFEId: "",
    };
  },
  created() {
    const { CFEId } = this.$route.query;
    this.CFEId = CFEId;
  },
  methods: {
    getList() {
      var param = {
        CFEId: this.CFEId,
      };
      this.$api.financialManagement
        .getCustomerFundExchangeRecordByCFEId(param)
        .then((res) => {
          this.tableData = res.data;
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.clientFundExchange {
  ::v-deep .number-label {
    line-height: 33px;
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .list {
    width: 100%;
    display: inline-block;
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .warning-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: #ffba00;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-top: 5px;
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
}
</style>
